import { createApp } from '@backstage/frontend-defaults';
import { createFrontendModule, PageBlueprint } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { microsoftAuthApiRef } from '@backstage/core-plugin-api';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import notificationsPlugin from '@backstage/plugin-notifications/alpha';
import { navModule } from './modules/nav';
import { homeModule } from './modules/home';
import { scaffolderUserPrefillModule } from './modules/scaffolderUserPrefill';
import { ownerProfileFieldsModule } from './modules/ownerProfileFields';
import { entityValuesYamlModule } from './modules/entityValuesYaml';
import { customCatalogTableModule } from './modules/customCatalogTable';

// The new-system template mounts catalog at /catalog and home at /home, so a
// bare visit to / lands on the 404 page. Redirect the root to the catalog.
const rootRedirectPage = PageBlueprint.make({
  params: {
    path: '/',
    loader: async () => {
      const { Navigate } = await import('react-router');
      return <Navigate to="/catalog" replace />;
    },
  },
});

const appModuleRoot = createFrontendModule({
  pluginId: 'app',
  extensions: [rootRedirectPage],
});

// Overrides the app plugin's default sign-in page (hardcoded to guest-only).
// Microsoft Entra ID is the only sign-in method.
const customSignInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => {
      const { SignInPage } = await import('@backstage/core-components');
      return props => (
        <SignInPage
          {...props}
          providers={[
            {
              id: 'microsoft',
              title: 'Microsoft',
              message: 'Sign in with your ITSO account',
              apiRef: microsoftAuthApiRef,
            },
          ]}
        />
      );
    },
  },
});

const appModuleSignIn = createFrontendModule({
  pluginId: 'app',
  extensions: [customSignInPage],
});

// notificationsPlugin (alpha) registers the notifications API implementation
// that the nav module's NotificationsSidebarItem requires; without it the UI
// crashes with "No implementation available for apiRef{plugin.notifications.service}".
export default createApp({
  features: [
    customCatalogTableModule,
    catalogPlugin,
    notificationsPlugin,
    navModule,
    homeModule,
    appModuleSignIn,
    appModuleRoot,
    scaffolderUserPrefillModule,
    ownerProfileFieldsModule,
    entityValuesYamlModule,
  ],
});
